module.exports = __webpack_public_path__ + "static/img/Thoracic_organs.d7580b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/organs/Thoracic_organs.png
// module id = Szzi
// module chunks = 1